<app-page-header
        [title]="'Sample Category Details'"
        [subtitle]="'View details of the selected sample category'">
</app-page-header>

@if (sampleCategory) {
    <div class="mb-5">
    <h2>{{ sampleCategory.name }}</h2>
    <p><strong>ID:</strong> {{ sampleCategory.id }}</p>
        @if (sampleCategory.defaultWeight !== null) {
            <p>
        <strong>Default Weight:</strong> {{ sampleCategory.defaultWeight }}
            </p>
        }
        @if (sampleCategory.tariffCode) {
            <p>
        <strong>Tariff Code:</strong> {{ sampleCategory.tariffCode }}
            </p>
        }
    <p>
        <strong>Sample Type ID:</strong> {{ sampleCategory.sampleTypeId }}
    </p>
    <p><strong>Created By:</strong> {{ sampleCategory.createdBy | roleName }}</p>
    <p><strong>Updated By:</strong> {{ sampleCategory.updatedBy | roleName }}</p>
    </div>
}
<div class="mb-6">
    <h2 class="text-2xl font-semibold mb-2">Details</h2>
    <div class="border border-gray-300 dark:border-gray-700 p-4 rounded-md flex flex-col">
        <p-table
                [value]="details"
                [tableStyle]="{'min-width': '50rem'}"
                scrollable="true"
                scrollHeight="300px"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Naming Relevant</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-detail>
                <tr>
                    <td>{{ detail.name }}</td>
                    <td>{{ detail.isNamingRelevant ? 'Yes' : 'No' }}</td>
                    <td>
                        <div class="flex justify-end gap-2">
                            <p-button
                                    icon="pi pi-eye"
                                    text
                                    pTooltip="View detail"
                                    tooltipPosition="left"
                                    [routerLink]="'/details/detail/' + detail.id">
                            </p-button>

                            <p-button
                                    canManageSampleDefinitions
                                    icon="pi pi-minus"
                                    text
                                    pTooltip="Remove detail"
                                    tooltipPosition="left"
                                    (click)="removeDetail(detail)"
                                    severity="danger">
                            </p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
        <p-button
                canManageSampleDefinitions
                label="Assign Detail"
                icon="pi pi-plus"
                (click)="openAddDetailsDialog()"
                class="mt-5">
        </p-button>
    </div>
</div>

<div class="flex justify-between gap-2">
    <div>
        <p-button
                canManageSampleDefinitions
                label="Edit"
                icon="pi pi-pencil"
                (click)="openEditDialog()"
                text>
        </p-button>
        <p-button
                canManageSampleDefinitions
                label="Delete"
                icon="pi pi-trash"
                (click)="confirmDelete()"
                severity="danger"
                text>
        </p-button>
    </div>
    <p-button
            label="Back to Sample Type"
            icon="pi pi-arrow-left"
            [routerLink]="'/sample-types/sample-type/' + sampleCategory?.sampleTypeId">
    </p-button>
</div>

<!-- Update Dialog -->
<app-update-sample-category-dialog
        [(visible)]="displayUpdateDialog"
        [sampleCategory]="editableSampleCategory"
        (sampleCategoryUpdated)="reloadSampleCategoryDetails()">
</app-update-sample-category-dialog>

<app-add-details-to-category-dialog
        [(visible)]="displayAddDetailsDialog"
        [category]="sampleCategory"
        (saved)="reloadSampleCategoryDetails()">
</app-add-details-to-category-dialog>
